
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/search",
      function () {
        return require("private-next-pages/blog/search.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/search"])
      });
    }
  